import { initSearchForm } from './components/search-form'

initSearchForm()
